import http from 'plugins/axios';

export function tenantInfo(data) {
    return http.get({
        url: `/ta/admin/tenant/info`,
        data
    })
}


export function positionOrderList(data) {
    return http.get({
        url: `/ta/admin/channel/order/positionOrderList`,
        data,
    })
}